<script setup lang="ts">
import type { HTMLAttributeClass } from '@shared/fondof-ui/types'
import clsx from 'clsx'

const props = defineProps<HTMLAttributeClass>()
</script>

<template>
  <div :class="clsx(['min-w-0 shrink-0 select-none last:mr-0'], props.class)">
    <slot />
  </div>
</template>
